import React from "react";

const Common_document = () => {
  return <div>Common_document</div>;
};

export default Common_document;
